// Login / Ver pedidos
(function () {
  'use strict';

  // Variáveis
  const $campoEmail = $('#mdl-mail');
  const $btnLogin = $('.mdl-btn');
  const $verifyCodeWrp = $('.verification-code-wrp');
  const $resendTxt = $('.mdl-resend-txt');
  const $resendLink = $('.mdl-resend-link');
  const btnTxt = {
    validar_email: 'Ver meus pedidos',
    validar_codigo: 'Validar código',
  };
  let curAcao = 'validar_email';
  let resendTimer;
  let resendSeconds = 60;
  let resendCountdown = resendSeconds;

  // Ao clicar no botão
  $btnLogin.on('click', function (ev) {
    ev.preventDefault();
    if (curAcao === 'validar_email') {
      validaEmailLogin();
    } else if (curAcao === 'validar_codigo') {
      validateCode();
    }
  });

  // Ao pressionar Enter no campo
  $campoEmail.on('keyup', function (ev) {
    if (ev.which === 13) {
      validaEmailLogin();
    }
  });

  // Ao clicar para solicitar um novo código
  $resendLink.on('click', 'a', function (ev) {
    ev.preventDefault();
    validaEmailLogin();
  });

  // Valida e-mail
  function validaEmailLogin() {
    if (isValidEmail($campoEmail.val())) {
      verifyEmailOrders();
    } else {
      showAlert('Atenção', 'Por favor, informe um e-mail válido.', 'warning');
    }
  }

  // Reseta código de verificação
  function resetVerificationCode() {
    $verifyCodeWrp.hide();
    $resendTxt.hide();
    $resendLink.hide();
    curAcao = 'validar_email';
    $btnLogin.text(btnTxt[curAcao]);
  }

  // Verifica o e-mail e envia o código
  function verifyEmailOrders() {
    if (!previewMode) {
      let email = $campoEmail.val().trim();
      const urlVerifica = urlBase + 'core/acoes/themes/boosterstore/pedidos/verificacao.php';
      const data = {
        acao: 'verifica_email',
        email: email,
        lp: baseLanding,
        store_token: publicToken,
      };
      $resendTxt.find('span').text(resendSeconds);
      $resendLink.hide();
      showLoader();
      $.getJSON(urlVerifica, data, function (result) {
        console.log(result);
        hideLoader();
        if (result && result.status === 'success') {
          curAcao = 'validar_codigo';
          $btnLogin.text(btnTxt[curAcao]);
          $('.verification-code input').val('');
          $verifyCodeWrp.show();
          $resendTxt.show();
          setTimeout(() => {
            $('.verification-code input').first().focus();
          }, 100);
          resendTimer = setInterval(() => {
            resendCountdown--;
            $resendTxt.find('span').text(resendCountdown);
            if (resendCountdown === 0) {
              clearInterval(resendTimer);
              resendCountdown = resendSeconds;
              $resendTxt.hide();
              $resendLink.show();
            }
          }, 1000);
        } else {
          resetVerificationCode();
          showAlert(
            'Não encontrado',
            'Não encontramos nenhum pedido para o e-mail informado. Por favor, verifique se você digitou o e-mail correto.',
            'danger',
          );
        }
      }).fail(function (qXHR, textStatus, errorThrown) {
        console.log(qXHR);
        resetVerificationCode();
        hideLoader();
        showAlert('Erro', 'Não foi possível verificar o e-mail.', 'danger');
      });
    }
  }

  // Obtém o código informado
  function getVerificationCode() {
    let code = '';
    $('.verification-code input').each(function () {
      code += $(this).val();
    });
    if (code.length === 5) {
      return code;
    }
    return false;
  }

  // Valida o codigo
  function validateCode() {
    const code = getVerificationCode();
    if (!code) {
      showAlert('Atenção', 'Informe o código de verificação completo.', 'warning');
      return false;
    }
    const urlVerifica = urlBase + 'core/acoes/themes/boosterstore/pedidos/verificacao.php';
    const data = {
      acao: 'verifica_codigo',
      code: code,
      email: $campoEmail.val().trim(),
      store_token: publicToken,
      url_base: urlBase,
    };
    showLoader();
    $.getJSON(urlVerifica, data, function (result) {
      console.log(result);
      if (result && result.status === 'success') {
        window.location.href = result.url_redirect;
      } else {
        hideLoader();
        showAlert('Código inválido!', 'Verique novamente o código enviado para o seu e-mail.', 'danger');
      }
    }).fail(function (qXHR, textStatus, errorThrown) {
      console.log(qXHR);
      hideLoader();
      showAlert('Erro', 'Não foi possível validar o código.', 'danger');
    });
  }
})();

// Campo de verificação de código
(function () {
  'use strict';
  if ($('.verification-code').length) {
    // Variáveis
    const $verificatioWrp = $('.verification-code');
    const inputs = $verificatioWrp[0].querySelectorAll('input');
    const KEYBOARDS = {
      backspace: 8,
      arrowLeft: 37,
      arrowRight: 39,
    };

    function handleInput(e) {
      const input = e.target;
      const nextInput = input.nextElementSibling;
      if (nextInput && input.value) {
        nextInput.focus();
        if (nextInput.value) {
          nextInput.select();
        }
      }
    }

    function handlePaste(e) {
      e.preventDefault();
      const paste = e.clipboardData.getData('text');
      inputs.forEach((input, i) => {
        input.value = paste[i] || '';
      });
    }

    function handleBackspace(e) {
      const input = e.target;
      if (input.value) {
        input.value = '';
        return;
      }

      if (input.previousElementSibling) {
        input.previousElementSibling.focus();
      }
    }

    function handleArrowLeft(e) {
      const previousInput = e.target.previousElementSibling;
      if (!previousInput) return;
      previousInput.focus();
    }

    function handleArrowRight(e) {
      const nextInput = e.target.nextElementSibling;
      if (!nextInput) return;
      nextInput.focus();
    }

    $(inputs).on('input', handleInput);
    inputs[0].addEventListener('paste', handlePaste);

    inputs.forEach((input) => {
      input.addEventListener('focus', (e) => {
        setTimeout(() => {
          e.target.select();
        }, 0);
      });

      input.addEventListener('keydown', (e) => {
        switch (e.keyCode) {
          case KEYBOARDS.backspace:
            handleBackspace(e);
            break;
          case KEYBOARDS.arrowLeft:
            handleArrowLeft(e);
            break;
          case KEYBOARDS.arrowRight:
            handleArrowRight(e);
            break;
          default:
        }
      });
    });
  }
})();
